import { useDispatch, useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/todo/api/todoApi";
import { addColor, addOption } from "../features/todo/todoSlice";

export const TodoFilter = () => {
    const { data, isLoading, isError } = useGetTodosQuery();
    const dispatch = useDispatch();
    const { option, colors } = useSelector((state) => state.filter) || {};

    // not completed task count
    let completedTodos = 0;

    if (!isLoading && !isError) {
        completedTodos = data?.filter((todo) => !todo.completed);
    }

    const optionHandler = (option) => {
        dispatch(addOption(option));
    };

    const colorSelect = (color) => {
        dispatch(addColor(color));
    };

    return (
        <>
            <div className="mt-4 flex justify-between text-xs text-gray-500">
                <p>
                    {completedTodos.length !== 0
                        ? completedTodos.length + " tasks left"
                        : "Empty Task"}
                </p>
                <ul className="flex space-x-1 items-center text-xs">
                    <li
                        onClick={() => optionHandler("all")}
                        className={`cursor-pointer ${
                            option === "all" && "font-bold"
                        } `}
                    >
                        All
                    </li>
                    <li>|</li>
                    <li
                        onClick={() => optionHandler("incomplete")}
                        className={`cursor-pointer ${
                            option === "incomplete" && "font-bold"
                        } `}
                    >
                        Incomplete
                    </li>
                    <li>|</li>
                    <li
                        onClick={() => optionHandler("complete")}
                        className={`cursor-pointer ${
                            option === "complete" && "font-bold"
                        } `}
                    >
                        Complete
                    </li>
                    <li></li>
                    <li></li>
                    <li
                        onClick={() => colorSelect("green")}
                        className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
                            colors.includes("green") && "bg-green-500"
                        } `}
                    ></li>
                    <li
                        onClick={() => colorSelect("red")}
                        className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
                            colors.includes("red") && "bg-red-500"
                        }`}
                    ></li>
                    <li
                        onClick={() => colorSelect("yellow")}
                        className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
                            colors.includes("yellow") && "bg-yellow-500"
                        }`}
                    ></li>
                </ul>
            </div>
        </>
    );
};
